<template>
  <div class="text-center primary--text">
    <v-btn
      v-if="isLoggedIn"
      :outlined="!hasUserVoted"
      small
      color="accent"
      :aria-label="label"
      @click="handleVote"
    >
      <v-icon aria-hidden="true">{{ mdiArrowUp }}</v-icon>
    </v-btn>
    <span class="d-sr-only" role="status" aria-atomic="true"
      >{{ votesCount }} votes</span
    >
    <div class="mt-1" aria-hidden="true">
      <div class="font-weight-bold">{{ votesCount }}</div>
      <div>Votes</div>
    </div>
  </div>
</template>

<script>
import { mdiArrowUp } from "@mdi/js";

export default {
  name: "CommunityDiscussionVote",
  props: {
    isLoggedIn: { type: Boolean, required: true },
    hasUserVoted: { type: Boolean, required: true },
    votesCount: { type: Number, required: true },
    title: { type: String, required: true },
  },
  data() {
    return {
      // Icons
      mdiArrowUp,
    };
  },

  computed: {
    label() {
      return this.hasUserVoted
        ? `Remove vote for ${this.title}`
        : `Add vote for ${this.title}`;
    },
  },

  methods: {
    handleVote() {
      if (this.hasUserVoted) {
        this.$emit("unvoted");
      } else {
        this.$emit("voted");
      }
    },
  },
};
</script>
